import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { AgreementApp } from "@modules/agreementApps/types";
import { AgreementAppFormValues } from "@modules/agreementApps/validations";

export async function createAgreementAppService(
  data: AgreementAppFormValues
): Promise<AgreementApp> {
  const formatedData = appendFormData(data);
  const headers: any =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const { data: agreement } = await api.post<AgreementApp>(
    "v1/agreement_app_admin/",
    data,
    {
      headers,
    }
  );

  return agreement;
}
